import { type MetaFunction, data } from 'react-router'
import { SiteShell } from '#app/components/site/SiteShell'
import { HomePage } from '#app/components/site/home/HomePage'
import { rememberAudience } from '#app/utils/site/audience.server'
import { siteContent } from '#app/utils/site/content'
import { siteLinks } from '#app/utils/site/site-links'
import { siteMeta } from '#app/utils/site/site-meta'

/** Tells the root layout to render no NavBar: the SiteShell is the chrome. */
export const handle = { chrome: 'site' } as const
export const links = siteLinks()
export const meta: MetaFunction = () => siteMeta(siteContent.meta.tenant)

/** The tenant side of the website. Visiting it remembers "tenant". */
export async function loader() {
	return data(
		{ audience: 'tenant' as const },
		{ headers: await rememberAudience('tenant') },
	)
}

export default function HomeRoute() {
	return (
		<SiteShell audience="tenant" hasPhotoHero>
			<HomePage audience="tenant" />
		</SiteShell>
	)
}
